import {
  GET_ALL_TAGS,
  GET_ALL_RAMAIS,
  GET_ALL_CENTRO_DE_CUSTOS,
  GET_DADOS_RELATORIO,
  GET_ALL_CONFERENCIAS,
} from './mutation-types'

export default {
  [GET_ALL_TAGS]: (state, tags) => {
    state.tags = tags
  },
  [GET_ALL_RAMAIS]: (state, ramais) => {
    state.ramais = ramais
  },
  [GET_ALL_CENTRO_DE_CUSTOS]: (state, centroDeCustos) => {
    state.centroDeCustos = centroDeCustos
  },
  [GET_DADOS_RELATORIO]: (state, dadosRelatorio) => {
    state.dadosRelatorio = dadosRelatorio
  },
  [GET_ALL_CONFERENCIAS]: (state, conferencias) => {
    state.conferencias = conferencias
  },
}
